// extracted by mini-css-extract-plugin
module.exports = {"lpButton":"Buttons_lpButton__n7hgz"};